<template>
    <div>
      <font-awesome-icon
        :icon="['fas', result.icon ]"
        :class="result.color"
      />
      <span
        class="report__resultRow__text"
      >{{$t('report.temp')}}.: {{parseFloat(batteryTemperature).toFixed(0)}} ℃</span>

    </div>
</template>

<script>
    export default {
      name: "TemperatureResult",
      props: {
        temperatureMin: {
          default: 10
        },
        temperatureMax: {
          default: 50
        },
        batteryTemperature: {
          required: true
        }
      },
      data() {
        return {
          temperatureResultMap: {
            "bad": {
              icon: "times-circle",
              color: "red-icon",
              message: this.$t('report.badCondition')
            },
            "good": {
              icon: "check-circle",
              color: "green-icon",
              message: this.$t('report.goodCondition')
            }
          }
        }
      },
      computed: {
        result: function() {
          if(
            (Number(this.batteryTemperature) - Number(this.temperatureMax)) *
            (Number(this.batteryTemperature) - Number(this.temperatureMin)) <=
            0
          ) {
            return this.temperatureResultMap['good'];
          }
          return this.temperatureResultMap['bad'];

        }
      }
    }
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

svg {
  margin-right: 15px;
}

.red-icon {
  color: $red;
}

.green-icon {
  color: $green;
}

.yellow-icon {
  color: $orange;
}

.blue-icon {
  color: $primary;
}
</style>
